"use client";

import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "@/hooks";
import { AppDispatch } from "@/store";
import { UseStatisticalReportProps } from "@/types/hooks/statisticalReport";
import { fetchStatisticalReport } from "@/store/modules/reports/thunks";
import { fetchEmployees } from "@/store/modules/employees/thunks";

const useStatisticalReport = ({
  dateRange,
  filters,
  onSuccess,
}: UseStatisticalReportProps) => {
  const { params, setParams, handlePage } = useParams();
  const { per_page, current_page } = params;

  const { loading, error } = useSelector((state: any) => state.reports);

  const statisticalReport = useSelector(
    (state: any) => state.reports.statisticalReport,
  );

  const dispatch: AppDispatch = useDispatch();

  const { employees } = useSelector((state: any) => state.employees);

  useEffect(() => {
    dispatch(fetchEmployees(params));
  }, [dispatch]);

  // Busca automática inicial (apenas uma vez)
  useEffect(() => {
    if (dateRange?.start && dateRange?.end) {
      const payload = {
        ...params,
        start_date: dateRange.start.toISOString().split("T")[0],
        end_date: dateRange.end.toISOString().split("T")[0],
        employee_id: filters.employee_id,
        type: filters.type,
        status: filters.status,
        order_by: filters.order_by,
      };

      dispatch(fetchStatisticalReport(payload));
    }
  }, [dateRange, params, dispatch]);

  const handleSubmitFilter = () => {
    const payload: Record<string, any> = {
      ...params,
      start_date: dateRange.start.toISOString().split("T")[0],
      end_date: dateRange.end.toISOString().split("T")[0],
      employee_id: filters.employee_id,
      type: filters.type,
      status: filters.status,
      order_by: filters.order_by,
    };

    dispatch(fetchStatisticalReport(payload));
  };

  const totalItems = statisticalReport?.total ?? 0;
  const itemsPerPage = statisticalReport?.per_page ?? 10;
  const totalPages = totalItems > 0 ? Math.ceil(totalItems / itemsPerPage) : 1;

  const [currentPage, setCurrentPage] = useState(
    statisticalReport?.current_page ?? 1,
  );

  useEffect(() => {
    if (
      statisticalReport?.current_page &&
      statisticalReport.current_page !== currentPage
    ) {
      setCurrentPage(statisticalReport.current_page);
    }
  }, [statisticalReport?.current_page]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    handlePage(page);
  };

  return {
    statisticalReport,
    employees,
    loading,
    error,
    handleSubmitFilter,
    currentPage,
    handlePageChange,
    totalPages,
    itemsPerPage,
  };
};

export default useStatisticalReport;
